

export default function TermSetDirective() {
    return {
        restrict: 'E',
        controller: 'TermSetController',
        controllerAs: 'termSet',
        template: require('./termSet.html'), // eslint-disable-line global-require
        bindToController: true,
        scope: {
            hasSelectColumn: '=',
            isSelectable: '=',
            isSelected: '=',
            status: '=',
            termSetData: '=',
            state: '=',
            premierTier: '='
        },
    };
}

// export default angular.module('directives.termSetDirective',[])
//     .directive('termSet', TermSetDirective)
//     .name;



// WEBPACK FOOTER //
// ./src/app/accounts/financing/termSetDirective/termSetDirective.js